import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../../assets/img/Loader.gif";
import {
  IconButton,
  Modal,
  Box,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  Collapse,
  Grid,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  CustomStyledButtonSolid,
  StyledButton,
  StyledTableCellHistory,
  StyledTableContainer,
  StyledTextField,
} from "../StyledComponents.js";
import { displayPatientName } from "../../../utils/displayPatientName";
import "../DoctorConsole.scss";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AbdmRecords from "../AbdmRecords/AbdmRecords";
import { styled } from "@mui/material/styles";
import { formatDateIST } from "../Utils/UtilsFunctions.js";
import { Icons } from "../Utils/iconsRegistry.js";
import Icon from "../Utils/Icons.js";

const ConsentHistory = ({ open, handleClose, patientData }) => {
  const [patientAbhaAddress, setPatientAbhaAddress] = useState(null);
  const [roleType, setRoleType] = useState(sessionStorage.getItem("roleType"));
  const themeColor = "red";
  const getStatusColor = (status) => {
    if (!status) return "gray";
    switch (status.toLowerCase()) {
      case "data received":
        return "green";
      case "granted":
        return "green";
      case "requested":
        return "#eed202";
      case "denied":
      case "revoked":
      case "error":
        return "red";
      case "expired":
        return "gray";
      default:
        return "gray";
    }
  };

  // Styled dot component
  const StatusDot = styled("span")(({ color }) => ({
    height: "10px",
    width: "10px",
    backgroundColor: color,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "8px",
  }));

  const StatusCell = ({ status, consent_details }) => {
    if (status == "PATIENT CONSENT APPROVAL PENDING") {
      status = "REQUESTED";
    } else if (status === "DATA EXPIRED") {
      status = "EXPIRED";
    } else if (status === "ERROR CREATING CONSENT") {
      status = "ERROR";
    }
    const color = getStatusColor(status);

    return (
      <StyledTableCellHistory>
        <StatusDot color={color} />
        {status ? status : "NOT FOUND"}
        {status === "GRANTED" && consent_details.data_received_at
          ? `  at ${formatDateIST(consent_details.data_received_at)}`
          : status === "DENIED" && consent_details.denied_time
          ? `  at ${formatDateIST(consent_details.denied_time)}`
          : status === "REVOKED" && consent_details.revoked_time
          ? `  at ${formatDateIST(consent_details.revoked_time)}`
          : null}
      </StyledTableCellHistory>
    );
  };
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [consentHistoryData, setConsentHistoryData] = useState([]);
  const organizeDataByCareContext = (data, hipId) => {
    const mainArray = [];
    data.forEach((item, iterationIndex) => {
      const { contextReference } = item;
      //find if carecontext already present or not
      const alreadyFound = mainArray.find(
        (entry) => entry.careContextReference === contextReference
      );

      let composition = item.content.find((entry) =>
        entry.hasOwnProperty("Composition")
      );
      console.log("Composition in useeffect", composition);

      let compositionSnomedCode = null;
      let key = "Display not found";

      if (composition) {
        compositionSnomedCode = composition?.Composition?.code?.[0]?.code;

        switch (compositionSnomedCode) {
          case "440545006":
            key = "Prescription";
            break;
          case "721981007":
            key = "Diagnostic Report";
            break;
          case "371530004":
            key = "OP Consultation";
            break;
          case "373942005":
            key = "Discharge Summary";
            break;
          case "41000179103":
            key = "Immunization Record";
            break;
          case "419891008":
            key = "Record artifact";
            break;
          case "1156871006":
            key = "Wellness Record";
            break;
        }
      }

      const compositionDate = composition?.Composition?.date?.split("T")[0];
      console.log("Snomed and hi type", compositionSnomedCode, key);

      if (alreadyFound) {
        //if care context already present then finding its index
        const index = mainArray.findIndex(
          (entry) => entry.careContextReference === contextReference
        );
        //in that particular index see if the date is already present or not
        const dateEntry = mainArray[index]["fhir_data"].find(
          (item) => item[compositionDate]
        );

        if (dateEntry) {
          //if date is already present then push the new hitype and its data to the date array
          dateEntry[compositionDate].push({ [key]: item.content });
        } else {
          //if date is not present then push a new obj to the mainArray of that carecontext index with date as its key and hi type and its resources as its value
          mainArray[index].fhir_data.push({
            [compositionDate]: [{ [key]: item.content }],
          });
        }
      } else {
        // if care context is not presnet then push a new obj to the main array with date as its key and hi type and its resources as its value
        const organizedData = {
          fhir_data: [{ [compositionDate]: [{ [key]: item.content }] }],
          careContextReference: contextReference,
          hipId: hipId,
        };
        mainArray.push(organizedData);
      }
    });

    return mainArray;
  };
  const handleGetConsentHistory = () => {
    let patient_abha_id = patientData
      ? patientData.abha_id
      : patientAbhaAddress;
    axios
      .get(
        `${REACT_APP_BACKEND_ROUTE_URL}get_data_transfer_consent_list/?patientAbhaID=` +
          patient_abha_id,
        {
          headers: headers,
          params: { status: true },
        }
      )
      .then((res) => {
        if (res.data?.data.length > 0) {
          console.log("Consent Data", res.data?.data);
          let updatedData = res.data?.data.map((data) => {
            const currentTime = new Date().toISOString();
            const isDataReceived = data.data_received_details.some(
              (detail) => detail.status === "DATA RECEIVED"
            );
            const isDataExpired =
              (data.consent_details.status === "GRANTED" ||
                data.consent_details.status ===
                  "PATIENT CONSENT APPROVAL PENDING") &&
              data.data_received_details.length === 0 &&
              data.consent_details.erase_at <= currentTime;

            return {
              ...data,
              consent_details: {
                ...data.consent_details,
                hi_types: JSON.parse(
                  data.consent_details.hi_types.replace(/'/g, '"')
                ),
                status: isDataExpired
                  ? "DATA EXPIRED"
                  : isDataReceived && data.consent_details.status === "GRANTED"
                  ? "DATA RECEIVED"
                  : data.consent_details.status,
              },
              data_received_details: data.data_received_details.map(
                (detail) => ({
                  ...detail,
                  fhir_list: organizeDataByCareContext(
                    detail.fhir_list,
                    detail.hip_id
                  ),
                })
              ),
              isOpen: false,
            };
          });
          updatedData.reverse();
          console.log("Updated Consent History Data", updatedData);
          setConsentHistoryData(updatedData);
        } else {
          setConsentHistoryData([]);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  useEffect(() => {
    if (patientData) {
      handleGetConsentHistory();
    }
  }, [patientData]);

  const handleExpandClick = (index) => {
    const newData = [...consentHistoryData];
    newData[index].isOpen = !newData[index].isOpen;
    setConsentHistoryData(newData);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="consent-history-modal-box">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            pt: 2,
            // backgroundImage: `url(${Icons.modal_blue})`,
            backgroundColor: "#213360",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            borderTopRightRadius: "8px",
            padding: "16px",
          }}
        >
          <Typography variant="h6" sx={{ color: "#ffff", fontWeight: 600 }}>
            Patient Consent History
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ color: "#fff" }}
          >
            <CloseIcon
              sx={{
                color: "#FFFFFF",
                fontSize: { xs: "1.2rem", sm: "1.5rem" },
              }}
            />
          </IconButton>
        </Box>

        {/* Divider line under header */}
        <Box sx={{ borderBottom: "1px solid #C7C7CC ", mt: 1, mr: 1, ml: 1 }} />
        <div style={{ padding: "10px" }}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={10}
              sm={10}
              md={10}
              display="flex"
              flexDirection="column-reverse"
            >
              <h1 className="console-heading" style={{ color: "#4DABF5" }}>
                Patient Details
              </h1>
            </Grid>
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <IconButton onClick={handleGetConsentHistory}>
                <RefreshIcon />
              </IconButton>
              <h2
                className="consent-history-demographics-heading"
                style={{ margin: "0px 8px" }}
              >
                Refresh
              </h2>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              {patientData ? (
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="space-between"
                  style={{ width: "100%" }}
                >
                  <Grid item xs={8} sm={8} md={6} style={{ textAlign: "left" }}>
                    <h2 className="consent-history-demographics-heading">
                      Patient Name: {displayPatientName(patientData?.name)}
                    </h2>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <h2 className="consent-history-demographics-heading">
                      Dob: {patientData.dob}
                    </h2>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={6}
                    sx={{ textAlign: "left", display: "flex", gap: 2 }}
                  >
                    <h2 className="consent-history-demographics-heading">
                      ABHA Address: {patientData.abha_id}
                    </h2>
                    <h2 className="consent-history-demographics-heading">
                      Gender: {patientData.gender}
                    </h2>
                  </Grid>

                  {/* <Grid item xs={3} sm={3} md={1.5}>
                  <h2 className="consent-history-demographics-heading">
                    Gender: {patientData.gender}
                  </h2>
                </Grid> */}

                  <Grid
                    item
                    xs={8}
                    sm={8}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <h2 className="consent-history-demographics-heading">
                      ABHA Number: {patientData?.abha_no ?? "NA"}
                    </h2>
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={2} xs={12} sm={8} md={6}>
                  <Grid item xs={12} sm={8} md={6}>
                    <StyledTextField
                      label="Enter ABHA Address"
                      fullWidth
                      onChange={(e) => setPatientAbhaAddress(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={6}>
                    <CustomStyledButtonSolid
                      onClick={handleGetConsentHistory}
                      sx={{ width: "100%" }}
                    >
                      Submit
                    </CustomStyledButtonSolid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>

          {consentHistoryData.length > 0 ? (
            <TableContainer
              component={Paper}
              sx={{
                border: "1px solid #176BAD",
                overflowX: "auto",
                margin: "10px 5px",
                borderRadius: "10px",
                boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCellHistory>
                      Creation Date And Time
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>From Date</StyledTableCellHistory>
                    <StyledTableCellHistory>To Date</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Expiry Date And Time
                    </StyledTableCellHistory>

                    <StyledTableCellHistory>
                      Selected Hi Types
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>Status</StyledTableCellHistory>
                    {roleType === "doctor" && (
                      <StyledTableCellHistory>Action</StyledTableCellHistory>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {consentHistoryData.map((row, rowIndex) => {
                    return (
                      <>
                        <TableRow key={rowIndex}>
                          <StyledTableCellHistory sx={{ width: "13%" }}>
                            {row.consent_details.created_time
                              ? formatDateIST(
                                  row?.consent_details?.created_time
                                )
                              : "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory sx={{ width: "8%" }}>
                            {row.consent_details.date_from
                              ? formatDateIST(
                                  row?.consent_details?.date_from,
                                  "From Date"
                                )
                              : "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory sx={{ width: "8%" }}>
                            {formatDateIST(
                              row?.consent_details?.date_to,
                              "To Date"
                            )}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory sx={{ width: "13%" }}>
                            {formatDateIST(row?.consent_details?.erase_at)}
                          </StyledTableCellHistory>

                          <StyledTableCellHistory sx={{ width: "35%" }}>
                            {row?.consent_details?.hi_types?.map(
                              (type, index) => (
                                <span
                                  key={index}
                                  style={{ fontStyle: "normal", fontSize: 12 }}
                                >
                                  {type}
                                  {index <
                                  row.consent_details.hi_types.length - 1
                                    ? ", "
                                    : ""}
                                </span>
                              )
                            )}
                          </StyledTableCellHistory>

                          <StatusCell
                            sx={{ width: "10%" }}
                            status={row?.consent_details?.status}
                            consent_details={row?.consent_details}
                          />
                          {roleType === "doctor" && (
                            <StyledTableCellHistory>
                              {(roleType === "doctor" &&
                                row?.consent_details?.status === "GRANTED") ||
                              row?.consent_details?.status ===
                                "DATA RECEIVED" ? (
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  onClick={() => handleExpandClick(rowIndex)}
                                  sx={{ marginLeft: "-12px" }}
                                >
                                  {roleType === "doctor" &&
                                    (row.isOpen ? (
                                      <KeyboardArrowUpIcon />
                                    ) : (
                                      <KeyboardArrowDownIcon />
                                    ))}
                                </IconButton>
                              ) : (
                                "-"
                              )}
                            </StyledTableCellHistory>
                          )}
                        </TableRow>
                        {row?.consent_details?.status === "GRANTED" &&
                          roleType === "doctor" && (
                            <TableRow>
                              <StyledTableCellHistory
                                colSpan={6}
                                style={{ paddingBottom: 0, paddingTop: 0 }}
                              >
                                <Collapse in={row.isOpen} unmountOnExit>
                                  <Box margin={1} full>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span style={{ marginRight: "10px" }}>
                                        Fetching Data
                                      </span>
                                      <img
                                        style={{
                                          zIndex: 9997,
                                          height: "1em", // This will match the text height
                                        }}
                                        src={Loader}
                                        alt="Loading..."
                                      />
                                    </div>
                                  </Box>
                                </Collapse>
                              </StyledTableCellHistory>
                            </TableRow>
                          )}
                        {row?.consent_details?.status === "DATA RECEIVED" &&
                          roleType === "doctor" && (
                            <TableRow>
                              <StyledTableCellHistory
                                colSpan={6}
                                style={{ paddingBottom: 0, paddingTop: 0 }}
                              >
                                <Collapse in={row.isOpen} unmountOnExit>
                                  <Box margin={1} full>
                                    {row.data_received_details.length > 0 ? (
                                      row.data_received_details.map(
                                        (detail, detailIndex) => (
                                          <>
                                            {detail.fhir_list.length > 0 ? (
                                              <AbdmRecords
                                                organizedArray={
                                                  detail.fhir_list
                                                }
                                              />
                                            ) : null}
                                          </>
                                        )
                                      )
                                    ) : (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <span style={{ marginRight: "10px" }}>
                                          Fetching Data
                                        </span>
                                        <img
                                          style={{
                                            zIndex: 9997,
                                            height: "1em", // This will match the text height
                                          }}
                                          src={Loader}
                                          alt="Loading..."
                                        />
                                      </div>
                                    )}
                                  </Box>
                                </Collapse>
                              </StyledTableCellHistory>
                            </TableRow>
                          )}
                      </>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            // <Typography sx={{ margin: "1rem 0.5rem" }}>
            //   No Consent Request Found
            // </Typography>
            <Box
              sx={{
                height: "50vh", // full viewport height
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", // vertical center
                alignItems: "center", // horizontal center
                textAlign: "center",
              }}
            >
              <Icon name="noConsentFound" size={128} />
              <Typography
                sx={{
                  margin: "1rem 0.5rem",
                  color: "#B1B1B1",
                  fontWeight: 600,
                }}
                variant="h6"
              >
                No Consent Request Found
              </Typography>
            </Box>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default ConsentHistory;
